<template>
  <html>
    <MenuApp />
    <div class="container">
      <div class="about">
        <h1>À propos de nous</h1>
        <p>
          Nous sommes une entreprise spécialisée dans l'impression de haute
          qualité, offrant des services personnalisés à nos clients.
        </p>
      </div>
    </div>
  </html>
</template>

<script>
import MenuApp from "./MenuApp.vue";
export default {
  name: "AboutStep",
  components: { MenuApp },
};
</script>

<style scoped>
.about {
  color: #000;
  max-width: 600px;
  margin: auto;
  padding: 20px;
}
</style>